<template>
  <div>
    <v-list-tile
      v-if="!isDropdown && item.visible"
      :to="{ name: `${item.component}` }"
      :class="[{ 'v-list__tile_active': currentPage }]"
    >
      <v-list-tile-action>
        <baseIcon>
          <component
            :is="item.icon"
            :icon-color="iconColor"
          />
        </baseIcon>
      </v-list-tile-action>
      <v-list-tile-title>{{ item.name }}</v-list-tile-title>
    </v-list-tile>
    <v-list-group
      v-else-if="isDropdown && item.visible"
      :value="item.visible"
      no-action
      append-icon=""
    >
      <template slot="activator">
        <v-list-tile :class="[{ 'v-list__tile_active': currentPage }]">
          <v-list-tile-action>
            <baseIcon>
              <component
                :is="item.icon"
                :icon-color="iconColor"
              />
            </baseIcon>
          </v-list-tile-action>
          <v-list-tile>
            <v-list-tile-title>{{ item.name }}</v-list-tile-title>
          </v-list-tile>
          <v-icon v-if="mobileScreen">
            keyboard_arrow_right
          </v-icon>
        </v-list-tile>
      </template>
      <template v-for="(child, i) in item.children">
        <v-list-tile
          v-if="child.visible"
          :key="i"
          :to="{ name: `${child.component}` }"
          :class="[{ 'v-list__tile__child_active': currentSubpage(child.component) }]"
        >
          <v-list-tile-title>
            {{ child.name }}
            <span v-if="hasLabel(child)">{{ childLabel(child) }}</span>
          </v-list-tile-title>
        </v-list-tile>
      </template>
    </v-list-group>
  </div>
</template>

<script>
import baseIcon from '@/icons/BaseIcon';
import DashboardIcon from '@/icons/DashboardIcon';
import FamiliesIcon from '@/icons/FamiliesIcon';
import PlanerIcon from '@/icons/PlanerIcon';
import StoreIcon from '@/icons/StoreIcon';
import GiftIcon from '@/icons/GiftIcon';
import ArchiveIcon from '@/icons/ArchiveIcon';
import StatsIcon from '@/icons/StatsIcon';
import has from 'lodash.has';

export default {
    name: 'MainMenuItem',
    components: {
        baseIcon,
        DashboardIcon,
        FamiliesIcon,
        PlanerIcon,
        StoreIcon,
        GiftIcon,
        ArchiveIcon,
        StatsIcon
    },
    props: {
        item: {
            type: Object
        }
    },
    computed: {
        isDropdown () {
            return has(this.item, 'children');
        },
        currentPage () {
            let _res = false;
            if (!this.isDropdown) {
                if (this.$route.name === this.item.component) {
                    _res = true;
                }
            } else {
                for (let i = 0; i < this.item.children.length; i++) {
                    if (this.$route.name === this.item.children[i].component) {
                        _res = true;
                    }
                }
            }
            return _res;
        },
        mobileScreen () {
            return this.$vuetify.breakpoint.xsOnly;
        },
        iconColor () {
            if (this.currentPage) {
                return '#fff';
            } else {
                return this.$vuetify.theme.sz_medium_grey;
            }
        }
    },
    methods: {
        currentSubpage (el) {
            if (this.$route.name === el) {
                return true;
            }
        },
        hasLabel (el) {
            return has(el, 'label');
        },
        childLabel (el) {
            switch (el.label) {
            case 'FTA_LENGTH':
                return this.$store.getters['familiesToAccept/getFamiliesToAccept'].length;
            case 'AF_LENGTH':
                return this.$store.getters['acceptedFamilies/getAcceptedFamiliesQuantity'];
            }
        }
    }
};
</script>

<style scoped></style>
